import { Grid, Typography, Button, alpha, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { InvoiceMissionTypeEnum } from 'src/shared/models/enums/invoiceMissionType.enum';
import { InvoiceMissionTypeItem } from '../models/invoiceMissionTypeItem';

type CreateInvoiceSelectMissionTypeProps = {
  createInvoiceMissionTypes: InvoiceMissionTypeItem[];
  callback: (val: InvoiceMissionTypeEnum) => void;
};

export const CreateInvoiceSelectMissionType = ({ createInvoiceMissionTypes, callback }: CreateInvoiceSelectMissionTypeProps) => {
  const { t } = useTranslation(['invoice']);

  const handleButtonClick = (val: InvoiceMissionTypeEnum) => callback(val);

  return (
    <Box
      sx={{
        p: {
          xs: 1,
          md: 3,
        },
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} textAlign='center'>
          <Typography variant='h5' sx={{ mb: 2 }}>
            {t('invoice:createInvoice.invoiceMissionSelectHeader')}
          </Typography>
        </Grid>
        {createInvoiceMissionTypes.map((mission) => (
          <React.Fragment key={mission.key}>
            <Grid item xs={12} md={createInvoiceMissionTypes.length === 2 ? 6 : 4}>
              <Button
                color='success'
                variant='outlined'
                fullWidth
                sx={{
                  py: 4,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                  height: '100%',
                  backgroundColor: '#fff',
                  '&:hover': {
                    backgroundColor: (theme) => alpha(theme.palette.success.light, 0.2),
                  },
                  '& .MuiSvgIcon-root': {
                    width: '5rem',
                    height: '5rem',
                    opacity: 0.4,
                    mb: 2,
                  },
                }}
                onClick={() => handleButtonClick(mission.key as InvoiceMissionTypeEnum)}
              >
                {mission.icon}
                <Typography variant='caption' sx={{ fontSize: '0.7rem', mb: 0.25, fontWeight: 100 }}>
                  {t('invoice:createInvoice.invoiceMissionSubHeader')}
                </Typography>
                <Typography variant='h5' component='div' sx={{ fontWeight: 100 }}>
                  {t(mission.label)}
                </Typography>
              </Button>
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </Box>
  );
};
